import { useSelector } from 'react-redux';
import { selectProjectId } from '../selectors';
import { useEffect } from 'react';
import { getCookie } from '../utils/cookie';
import { MAX_VISITED_PROJECTS_COUNT_FOR_UXFB, UXFB_VISITED_PROJECTS_COOKIE } from '../constants/uxfb';
import { setCookie } from '@cian/utils/lib/browser/cookie';

/** Обновляет посещенные проекты в куки для uxfb */
export const useUxfbVisitedProjectsUpdater = () => {
  const projectId = useSelector(selectProjectId);

  useEffect(() => {
    try {
      const visitedProjectsCookie = getCookie(UXFB_VISITED_PROJECTS_COOKIE) || '[]';
      const visitedProjects: number[] = JSON.parse(visitedProjectsCookie);

      if (visitedProjects.length < MAX_VISITED_PROJECTS_COUNT_FOR_UXFB && !visitedProjects.includes(projectId)) {
        setCookie(UXFB_VISITED_PROJECTS_COOKIE, JSON.stringify([...visitedProjects, projectId]));
      }
    } catch (e) {
      return;
    }
  }, [projectId]);
};
